import { JsonObject } from '../../../Assembler/dist/app/json/jsonObject.js';

/**
 * Represents a target file with its relative path and parsed JSON structure
 * Key is stored in the dictionary for fast lookup
 */
export class TargetFile {
    /** Relative path from AppSite folder (e.g., "Common/center") */
    relativePath: string = '';

    /** Parsed JSON structure (HtmlJson format with type-prefixed keys) */
    jsonStructure: JsonObject = new JsonObject();
}
